import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";
import * as service from "../service";

export const loginAPI = async (
  email: string,
  password: string,
  loginType: "student" | "business" | "admin" = "student",
) => {
  const { app_key } = store.getState().auth;

  let endpoint = "";
  let params: any = { password, app_key };
  if (loginType === "student") {
    endpoint = "api/user/login/student";
    params.university_email = email;
  } else if (loginType === "business") {
    endpoint = "api/user/login/business";
    params.email = email;
  } else if (loginType === "admin") {
    endpoint = "api/user/login/admin";
    params.username = email;
  }

  try {
    const resp = await service.call("POST", endpoint, params);
    return resp;
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`loginAPI ${err}`);
  }
};